import { combineReducers, configureStore } from '@reduxjs/toolkit';
import coreSliceReducer from './CoreSlice/core';
import authSliceReducer from '../authentication/modules/auth';
import tenantSliceReducer from '../tenant-admin/modules/tenants';
import userSliceReducer from '../user-admin/modules/users';
import notificationsSliceReducer from './NotificationsSlice/notifications';
import systemNotificationsSliceReducer from '../tenant-admin/modules/systemNotifications';


const staticReducers = combineReducers({
    core: coreSliceReducer,
    auth: authSliceReducer,
    tenants: tenantSliceReducer,
    users: userSliceReducer,
    notifications: notificationsSliceReducer,
    systemNotifications: systemNotificationsSliceReducer,
});




const rootReducer = (state, action) => {
    if(action.type === 'auth/logout') { 
        state = undefined; 
    }
    return staticReducers(state, action);
};
const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck:{
            ignoredActionPaths: ['payload', 'meta.arg'],
        },
    }),
});

export default store;
